import React, { useState, useEffect, useRef } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { useLocation } from "@reach/router"
import GlobalPopUpForm from "../../components/forms/global-popup-form"
import Modal from 'react-bootstrap/Modal'
import parse from "html-react-parser"

// Module-level variable prevents multiple auto-popups across remounts
let globalTimerFired = false

const GlobalFormModal = ({ showGlobalForm: manualTrigger, closeGlobalForm, modalTitle, modalCTA }) => {
    const data = useStaticQuery(graphql`
      query GlobalPopup {
        glstrapi {
          globalConfig {
            show_popup
            show_popup_form
            popup_form_pages
            popup_form {
              id
              _id
              form_name
              cta
              link
              mail
              popup_time
              title_content
              image {
                alternativeText
                url
              }
            }
          }
        }
      }
    `);

    const popup_form = data?.glstrapi?.globalConfig?.popup_form
    const { pathname, href } = useLocation()
    const popup_form_pages = data?.glstrapi?.globalConfig?.popup_form_pages
    const show_popup = data?.glstrapi?.globalConfig?.show_popup
    const show_popup_form = data?.glstrapi?.globalConfig?.show_popup_form
    const { title_content, image, cta, mail, link, form_name } = popup_form || {}

    const [show, setShow] = useState(false)
    const [render, setRender] = useState(false)

    const handleClose = () => {
        setShow(false)
        setRender(false)
        closeGlobalForm && closeGlobalForm(false)
    }

    // ===== AUTO-POPUP =====
    useEffect(() => {
        if (globalTimerFired) return
        if (!pathname.includes("the-renters-rights-act") || !show_popup) return

        let isMatch = false
        const splitSlug = popup_form_pages ? popup_form_pages.split(',') : []

        if (popup_form_pages === "all") isMatch = true
        else {
            pathname.split("/").forEach(slug => {
                if (slug && splitSlug.includes(slug)) isMatch = true
            })
            if (popup_form_pages.includes("home") && pathname === "/") isMatch = true
        }

        if (link && link === href) isMatch = false
        if (!isMatch) return

        globalTimerFired = true
        const timer = setTimeout(() => {
            setShow(true)
            setRender(true)
        }, 10000)

        return () => clearTimeout(timer)
    }, [])

    // ===== MANUAL TRIGGER =====
    useEffect(() => {
        if (manualTrigger) {
            setShow(true)
            setRender(true)
        }
    }, [manualTrigger])

    // Use props override if provided
    const displayTitle = modalTitle || title_content
    const displayCTA = modalCTA || cta

    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName={`global-modal-popup modal-form-wrapper form-page-wrapper ${!show_popup_form ? "no-modal-form" : ""}`}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <div className={`content ${!image || image?.length === 0 ? "popup-without-image" : ""}`}>
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        <div className="form-page-heading">
                            <div className="content-section">
                                {displayTitle && parse(displayTitle)}
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="popup-form-modal-body">
                    <div className="popup-form-modal-content">
                        {show_popup_form ? (
                            <div className="form-page-form-details global-popup-form">
                                <GlobalPopUpForm cta={displayCTA} to_email_id={mail} formname={form_name} />
                            </div>
                        ) : (
                            <div className="popup-cta-sec">
                                <Link to={link} className="btn btn-banner">{displayCTA}</Link>
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    )
}

export default GlobalFormModal